angular.module('unica_wiki.wiki_services')

.factory('WikiListService', function ($http, getBaseApiURL) {

	var wikiListService = {};

	wikiListService.list = function (limit, offset)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/wiki/list',
			data: {
				limit: limit,
				offset: offset
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.changelogs;
			}

		});

	};

	wikiListService.fullList = function ()
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/wiki/full-list',
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.changelogs;
			}

		});
	};

	wikiListService.get = function (wikiId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/wiki/detail/' + wikiId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.changelog;
			}

		});
	};

	return wikiListService;
});